export type CukcukMappingStatus = 'mapped' | 'unmapped';

export interface CukcukMappingFields {
  cukcukMaterialCode: string | null;
  cukcukUnit: string | null;
  cukcukWarehouseCode: string | null;
}

/**
 * Normalize a value received from a mapping form before it crosses the
 * Firestore boundary. Codes and units are intentionally case-preserving.
 */
export const normalizeCukcukValue = (value: unknown): string | null => {
  if (value === undefined || value === null) return null;
  if (typeof value !== 'string') {
    throw new Error('CUKCUK mapping value must be a string');
  }

  const trimmed = value.trim();
  return trimmed || null;
};

export const normalizeCukcukMappingFields = (raw: Partial<CukcukMappingFields>): CukcukMappingFields => ({
  cukcukMaterialCode: normalizeCukcukValue(raw.cukcukMaterialCode),
  cukcukUnit: normalizeCukcukValue(raw.cukcukUnit),
  cukcukWarehouseCode: normalizeCukcukValue(raw.cukcukWarehouseCode),
});

export const getCukcukMappingStatus = (mapping: {
  cukcukMaterialCode?: unknown;
  cukcukUnit?: unknown;
  cukcukWarehouseCode?: unknown;
}): CukcukMappingStatus => {
  const materialMapped = normalizeCukcukValue(mapping.cukcukMaterialCode) !== null;
  const unitMapped = normalizeCukcukValue(mapping.cukcukUnit) !== null;
  const warehouseMapped = normalizeCukcukValue(mapping.cukcukWarehouseCode) !== null;

  return (materialMapped && unitMapped) || warehouseMapped ? 'mapped' : 'unmapped';
};
